import React from "react";

const ContractERPDashboard = React.lazy(() => import("../../Contract/ContractERPDashboard"));
const CommissionSettings = React.lazy(() => import("../../Contract/CommissionSettings"));
const ContractTable = React.lazy(() => import("../../Accounts/Contracts/Contract/ContractTable"));
const ContractForm = React.lazy(() => import("../../Accounts/Contracts/Contract/ContractForm"));
const ContractForm2 = React.lazy(() => import("../../Accounts/Contracts/Contract/ContractForm2"));
const PaymentPlanScreen = React.lazy(
  () => import("../../Accounts/Contracts/PaymentPlan/PaymentPlanScreen"),
);
const CustomerTable = React.lazy(() => import("../../Accounts/Contracts/Customer/CustomerTable"));
const AddCustomerForm = React.lazy(() => import("../../Accounts/Contracts/Customer/CustomerForm"));
const MainAffiliates = React.lazy(() => import("../../Inventory/deals/Affiliates/MainAffiliates"));
const AffiliateForm = React.lazy(() => import("../../Inventory/deals/Affiliates/AffiliateForm"));
const InstallResceduleTable = React.lazy(
  () => import("../../Accounts/Contracts/InstallmentRescedule/InstallResceduleTable"),
);
const InstallResceduleform = React.lazy(
  () => import("../../Accounts/Contracts/InstallmentRescedule/InstallResceduleForm"),
);
const BallotTable = React.lazy(() => import("../../Accounts/Contracts/Ballot/BallotTable"));
const BallotForm = React.lazy(() => import("../../Accounts/Contracts/Ballot/BallotForm"));
const TransferContractTable = React.lazy(
  () => import("../../Accounts/Contracts/TransferContract/TransferContractTable"),
);
const TransferContractPage = React.lazy(
  () => import("../../Accounts/Contracts/TransferContract/TransferContractForm"),
);
const TransferUnitTable = React.lazy(
  () => import("../../Accounts/Contracts/TransferUnit/TransferUnitTable"),
);
const TransferUnitPage = React.lazy(
  () => import("../../Accounts/Contracts/TransferUnit/TransferUnitForm"),
);
const UnitsReport = React.lazy(() => import("../../Accounts/Reports/Units/Units"));
const CustomerDashboard = React.lazy(() => import("../../Accounts/Reports/Units/Customers"));
const AffiliateLeaderboardDashboard = React.lazy(
  () =>
    import("../../Accounts/Reports/AffiliateLeaderboardDashboard/AffiliateLeaderboardDashboard"),
);
const AffiliateCommissionReport = React.lazy(
  () => import("../../Accounts/Reports/AffiliateCommissionReport/AffiliateCommissionReport"),
);

export const salesRoutes = [
  {
    path: "/contract/settings/commission",
    Component: CommissionSettings,
    rolename: "Contract_Affiliates",
  },
  // Dashboard
  {
    path: "/contract/dashboard",
    component: <ContractERPDashboard />,
    rolename: "ERP-Contract_Dashboard",
  },
  {
    path: "/sales",
    component: <ContractERPDashboard />,
    rolename: "ERP-Contract_Dashboard",
  },
  {
    path: "/sales/dashboard",
    component: <ContractERPDashboard />,
    rolename: "ERP-Contract_Dashboard",
  },

  // Contracts
  {
    path: "/contract/contracts/with-unit",
    Component: ContractTable,
    props: { isFile: false },
    rolename: "Contracts_Contract With Unit",
  },
  {
    path: "/contract/contracts/without-unit",
    Component: ContractTable,
    props: { isFile: true },
    rolename: "Contracts_Contract Without Unit",
  },
  {
    path: "/contract/contracts/add-with-unit",
    Component: ContractForm,
    rolename: "Contracts_Contract With Unit",
  },
  {
    path: "/contract/contracts/add-without-unit",
    Component: ContractForm2,
    rolename: "Contracts_Contract Without Unit",
  },
  {
    path: "/contract/contracts/payment-plan",
    Component: PaymentPlanScreen,
    rolename: "ERP-Contracts_Payment Plan",
  },
  {
    path: "/contract/customers",
    Component: CustomerTable,
    rolename: "Contract_Customers",
  },
  {
    path: "/contract/customers/add",
    Component: AddCustomerForm,
    rolename: "Contract_Customers",
  },
  {
    path: "/contract/affiliates",
    Component: MainAffiliates,
    props: { type: "AffliateTable" },
    rolename: "Contract_Affiliates",
  },
  {
    path: "/contract/affiliates/add",
    Component: AffiliateForm,
    rolename: "Contract_Affiliates",
  },
  {
    path: "/contract/install-reschedule",
    Component: InstallResceduleTable,
    rolename: "Contract_Install Resch",
  },
  {
    path: "/contract/install-reschedule/add",
    Component: InstallResceduleform,
    rolename: "Contract_Install Resch",
  },
  {
    path: "/contract/ballot",
    Component: BallotTable,
    rolename: "Contract_Ballot",
  },
  {
    path: "/contract/ballot/add",
    Component: BallotForm,
    rolename: "Ballot_Create",
  },
  {
    path: "/contract/transfer-contract",
    Component: TransferContractTable,
    rolename: "Contract_Trans Contract",
  },
  {
    path: "/contract/transfer-contract/add",
    Component: TransferContractPage,
    rolename: "Contract_Trans Contract",
  },
  {
    path: "/contract/transfer-unit",
    Component: TransferUnitTable,
    rolename: "Contract_Transfer Unit",
  },
  {
    path: "/contract/transfer-unit/add",
    Component: TransferUnitPage,
    rolename: "Contract_Transfer Unit",
  },

  // Reports
  {
    path: "/contract/reports/units",
    Component: UnitsReport,
    rolename: "Reports_Units",
  },
  {
    path: "/contract/reports/customer",
    Component: CustomerDashboard,
    rolename: "Reports_Customer",
  },
  {
    path: "/contract/reports/affiliate-leaderboard",
    component: <AffiliateLeaderboardDashboard />,
    rolename: "ERP-Reports_Affiliate Leaderboard",
  },
  {
    path: "/contract/reports/affiliate-commission",
    Component: AffiliateCommissionReport,
    rolename: "ERP-Reports_Affiliate Commission",
  },
];

export const contractRoutes = salesRoutes;
